"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.toValidRGB=function(e){var r=e.map((function(e){return Number(e)<0?0:Number(e)>255?255:Number(e)}));return{r:r[0],g:r[1],b:r[2]}};
